import React from 'react';

const QuickNavigation = ({ navigate }) => {
    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="card bg-light border-0">
                    <div className="card-body py-3">
                        <div className="row text-center">
                            <div className="col-md-2 mb-2 mb-md-0">
                                <button
                                    className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center"
                                    onClick={() => navigate('/dashboard')}
                                >
                                    <i className="bi bi-speedometer2 me-2"></i>
                                    Dashboard
                                </button>
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <button
                                    className="btn btn-outline-success w-100 d-flex align-items-center justify-content-center"
                                    onClick={() => navigate('/statutory-report')}
                                >
                                    <i className="bi bi-people me-2"></i>
                                    Statutory
                                </button>
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <button
                                    className="btn btn-outline-info w-100 d-flex align-items-center justify-content-center"
                                    onClick={() => navigate('/payroll-approval')}
                                >
                                    <i className="bi bi-calendar2-week me-2"></i>
                                    Payroll Approval
                                </button>
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <button
                                    className="btn btn-outline-warning w-100 d-flex align-items-center justify-content-center"
                                    onClick={() => navigate('/payroll-export')}
                                >
                                    <i className="bi bi-calendar-event me-2"></i>
                                    Payroll Export
                                </button>
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <button
                                    className="btn btn-primary text-white w-100 d-flex align-items-center justify-content-center"
                                    disabled
                                >
                                    <i className="bi bi-calculator me-2"></i>
                                    Payroll
                                </button>
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">
                                <button
                                    className="btn btn-outline-dark w-100 d-flex align-items-center justify-content-center"
                                    onClick={() => navigate('/Menu')}
                                >
                                    <i className="bi bi-menu-button me-2"></i>
                                    Menu
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuickNavigation;